angular.module('app.api').factory('LogInApi', [
  'api',
  function LogInApi(api) {
    const logApi = {
      logIn: async payload => {
        const result = api.post('auth/login', payload, {withCredentials: true})
        console.debug('LogInApi.logIn', result)
        return result
      },
    }
    return logApi
  },
])



// WEBPACK FOOTER //
// ./scripts/sign-in/log-in.api.js